<template>
  <div>
    <v-tabs v-if="$route.path.indexOf('chat/') < 0 && $route.path.indexOf('topic/') < 0 "
            centered dark fixed-tabs show-arrows color="teal" v-model="active">
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab href="#home" @click="goTo('/c/' + communityId)">
        <v-icon color="white" medium>home</v-icon>
      </v-tab>
      <v-tab href="#chat" @click="goTo('/c/' + communityId + '/chat')">
        <v-icon color="white">fas fa-comments</v-icon>
      </v-tab>
      <v-tab href="#calendar" @click="goTo('/c/' + communityId + '/calendar')">
        <v-icon color="white" medium>event</v-icon>
      </v-tab>
      <v-tab href="#users" @click="goTo('/c/' + communityId + '/users')">
        <v-icon color="white">fac fa-users</v-icon>
      </v-tab>
      <v-tab href="#setting" @click="goTo('/c/' + communityId + '/setting')">
        <v-icon color="white">fas fa-cog</v-icon>
      </v-tab>
    </v-tabs>

    <router-view
      :user="user"
      :communityId="communityId"
      :communityName="communityName"
      :communityUsers="communityUsers"
      :isCommunityJoined="isCommunityJoined"
      :isCommunityOwner="isCommunityOwner"
      :colors="colors"
      :categories="categories"
      :about="about"
      :myChat="myChat"
      :isMyChatLoading="isMyChatLoading"
      :publicChat="publicChat"
      :isPublicChatLoading="isPublicChatLoading"
      @joinCommunity="joinCommunity"
      @createdCategory="createdCategory"
      @createdChat="createdChat"
      @editAbout="editAbout"
    ></router-view>

    <v-dialog v-model="welcomeDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <emoji :emoji="'tada'" class="pt-2" :size="36" set="google"/>
          Welcome&nbsp;"<span v-html="communityName"></span>"
        </v-card-title>

        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="teal" flat @click="joinCommunity()">
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import { Emoji } from 'emoji-mart-vue';

export default {
  name: 'CommunityCommon',
  components: {
    Emoji,
  },
  data: () => ({
    user: undefined,
    communityUsers: [],
    communityId: '',
    about: '',
    categories: [],
    isCommunityJoined: false,
    isCommunityOwner: false,
    welcomeDialog: false,
    myChat: [],
    isMyChatLoading: true,
    publicChat: [],
    isPublicChatLoading: true,
    active: 'home',
    colors: ['green', 'red', 'blue', 'purple', 'indigo', 'deep-orange', 'orange', 'pink', 'blue-grey', 'brown'],
  }),
  computed: {
    communityName() {
      return this.$store.state.communityName;
    },
  },
  created() {
    if (this.$route.path.indexOf('chat') >= 0) {
      this.active = 'chat';
    } else if (this.$route.path.indexOf('calendar') >= 0) {
      this.active = 'calendar';
    } else if (this.$route.path.indexOf('users') >= 0) {
      this.active = 'users';
    } else if (this.$route.path.indexOf('setting') >= 0) {
      this.active = 'setting';
    }

    this.communityId = this.$route.params.communityId;

    firebase.auth().onAuthStateChanged((user) => {
      this.user = user ? user : undefined;
      this.initialize();
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.path.indexOf('chat') >= 0) {
      this.active = 'chat';
    } else if (to.path.indexOf('calendar') >= 0) {
      this.active = 'calendar';
    } else if (to.path.indexOf('users') >= 0) {
      this.active = 'users';
    } else if (to.path.indexOf('setting') >= 0) {
      this.active = 'setting';
    } else {
      this.active = 'home';
    }

    if (to.params.communityId !== from.params.communityId && !to.params.chatId) {
      this.communityId = to.params.communityId;
      this.initialize();
    }

    next();
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    initialize() {
      // home
      this.getCommunity();

      // users
      this.getCommunityUsers();

      // categories
      this.getCategories();

      // chat
      this.isMyChatLoading = true;
      this.isPublicChatLoading = true;
      if (this.user) {
        this.getMyChat();
      } else {
        this.getPublicChat();
      }
    },
    getCommunity() {
      // home
      const communityRef = firebase.firestore().doc(`communities/${this.communityId}`);
      communityRef.get().then((communityDoc) => {
        if (communityDoc.exists) {
          this.$store.commit('changeCommunity', communityDoc.data().name);
          this.about = communityDoc.data().about;
        }
      }).catch((error) => {
        console.error(error);
      });

      // join
      if (this.user) {
        const communityUserRef = firebase.firestore().doc(`communities/${this.communityId}/users/${this.user.uid}`);
        communityUserRef.get().then((communityUserDoc) => {
          if (communityUserDoc.exists) {
            this.isCommunityJoined = true;
            this.isCommunityOwner = communityUserDoc.data().isOwner;
          } else {
            this.isCommunityJoined = false;
            this.welcomeDialog = true;
          }
        }).catch((error) => {
          console.error(error);
        });
      }
    },
    joinCommunity() {
      const user = {
        userRef: firebase.firestore().doc(`users/${this.user.uid}`),
        isNewbie: true,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      const communityUserRef = firebase.firestore().doc(`communities/${this.communityId}/users/${this.user.uid}`);
      communityUserRef.set(user).then(() => {
        this.isCommunityJoined = true;
        this.communityUsers.push({
          id: this.user.uid,
          name: this.user.displayName,
          avatar: this.user.photoURL,
          isCommunityNewbie: true,
        });
        this.welcomeDialog = false;
      }).catch((error) => {
        console.error(error);
      });
    },
    getCommunityUsers() {
      this.communityUsers = [];

      const communityUsersRef = firebase.firestore().collection(`communities/${this.communityId}/users`).orderBy('createdAt');

      communityUsersRef.get().then((querySnapshot) => {
        if (!querySnapshot.empty) {
          querySnapshot.forEach((communityUserDoc) => {
            communityUserDoc.data().userRef.get().then((userDoc) => {
              if (userDoc.exists) {
                this.addUserDoc(userDoc, communityUserDoc);
              }
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    addUserDoc(userDoc, communityUserDoc) {
      const user = userDoc.data();
      const communityUser = communityUserDoc.data();
      this.communityUsers.push({
        id: userDoc.id,
        name: user.name,
        avatar: user.avatar,
        isCommunityOwner: communityUser.isOwner,
        isCommunityNewbie: communityUser.isNewbie,
      });
    },
    getCategories() {
      this.categories = [];

      const categoriesRef = firebase.firestore().collection(`communities/${this.communityId}/categories`).orderBy('sort').orderBy('createdAt');

      categoriesRef.get().then((querySnapshot) => {
        if (!querySnapshot.empty) {
          querySnapshot.forEach((categoryDoc) => {
            this.addCategoryDoc(categoryDoc);
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    addCategoryDoc(categoryDoc) {
      const category = categoryDoc.data();
      this.categories.push({
        id: categoryDoc.id,
        name: category.name,
        color: category.color,
        sort: category.sort,
      });
    },
    getMyChat() {
      this.myChat = [];

      const myChatRef = firebase.firestore().collection(`users/${this.user.uid}/myChat`).orderBy('createdAt');
      myChatRef.get().then((snap) => {
        if (!snap.empty) {
          let count = 0;
          snap.forEach((doc) => {
            // TODO chatRef = doc.date().chatRef
            const chatRef = firebase.firestore().doc(`communities/${this.communityId}/chat/${doc.id}`);
            chatRef.get().then((chatDoc) => {
              if (chatDoc.exists) {
                this.addChatDoc(this.myChat, chatDoc, () => {
                  count += 1;
                  if (count === snap.size) {
                    this.isMyChatLoading = false;

                    // get explore chat
                    this.getPublicChat();
                  }
                });
              } else {
                count += 1;
                if (count === snap.size) {
                  this.isMyChatLoading = false;

                  // get explore chat
                  this.getPublicChat();
                }
              }
            });
          });
        } else {
          this.isMyChatLoading = false;

          // get explore chat
          this.getPublicChat();
        }
      }).catch((error) => {
        console.error(error);
        this.isMyChatLoading = false;

        // get explore chat
        this.getPublicChat();
      });
    },
    getPublicChat() {
      this.publicChat = [];

      const publicChatRef = firebase.firestore().collection(`communities/${this.communityId}/chat`).orderBy('createdAt');
      publicChatRef.get().then((snap) => {
        if (!snap.empty) {
          let count = 0;
          snap.forEach((doc) => {
            if (this.myChat.filter(chat => chat.id === doc.id).length !== 1) {
              this.addChatDoc(this.publicChat, doc, () => {
                count += 1;
                if (count === snap.size) {
                  this.isPublicChatLoading = false;
                }
              });
            } else {
              count += 1;
              if (count === snap.size) {
                this.isPublicChatLoading = false;
              }
            }
          });
        } else {
          this.isPublicChatLoading = false;
        }
      });
    },
    addChatDoc(chatList, chatDoc, callback = null) {
      const chat = {
        id: chatDoc.id,
        name: chatDoc.data().name,
        purpose: chatDoc.data().purpose,
        isPublic: chatDoc.data().isPublic,
        icon: chatDoc.data().icon,
        color: chatDoc.data().color,
      };

      const chatUsersRef = firebase.firestore().collection(`communities/${this.communityId}/chat/${chatDoc.id}/users`);
      chatUsersRef.get().then((userSnap) => {
        chat.userCount = userSnap.size;

        // TODO get unread count
        chat.unread = 1;
        chatList.push(chat);

        if (callback) callback();
      });
    },
    createdCategory(category) {
      this.categories.push(category);
    },
    createdChat(chat) {
      this.myChat.push(chat);
    },
    editAbout(about) {
      this.about = about;
    },
  },
};
</script>
